import base64logo from '@/assets/images/base64logo.json'
import { format, date, utc } from '@/helpers/datetime'

var content = []
var title = 'Customer Report'
var generatedDate = format(new Date(), 'D MMM YYYY h:mm:ss A')
var headerNumber = 0
var subHeaderNumber = 0
var customerLogo = ''

export default {
  // common fn
  append(_content) {
    content.push(_content)
  },
  clear() {
    content = []
    headerNumber = 0
    subHeaderNumber = 0
  },
  setTitle(_title) {
    title = _title
  },
  newPage() {
    this.append({
      text: '',
      pageBreak: 'after'
    })
  },
  addHeader(text) {
    // set numbering
    headerNumber += 1
    subHeaderNumber = 1

    this.append({
      text: `${headerNumber}. ${text}`,
      style: 'header',
      tocItem: true,
      margin: [0, 7]
    })
  },
  addSubHeader(text) {
    this.append({
      text: `${headerNumber}.${subHeaderNumber} ${text}`,
      style: 'subheader',
      tocItem: true,
      margin: [0, 7]
    })
    subHeaderNumber += 1
  },
  addCover(_customerLogo = '') {
    content.push({
      image: base64logo.reportBg,
      width: 700,
      absolutePosition: { x: 0, y: 80 },
      margin: [0, 0, 0, 20]
    })
    content.push({
      text: title,
      style: 'reportHeader',
      margin: [0, 150, 0, 50]
    })

    customerLogo = _customerLogo
    if (customerLogo) {
      content.push({
        image: customerLogo,
        width: 100,
        absolutePosition: { x: 470, y: 100 },
        margin: [0, 0, 0, 20]
      })
    }
  },
  addTOC() {
    var toc = [
      {
        toc: {
          title: { text: 'Table of Contents', style: 'header' },
          //textMargin: [0, 0, 0, 0],
          //textStyle: {italics: true},
          numberStyle: { bold: true }
        }
      }
    ]
    content = content.concat(toc)
  },
  setOrientation(type = 'portrait') {
    content.push({ text: '', pageOrientation: type, pageBreak: 'after' })
  },

  // table fn
  buildTableBody(data, columns) {
    var body = []

    body.push(columns)

    data.forEach(function (row) {
      var dataRow = []
      columns.forEach(function (column) {
        dataRow.push(row[column])
      })

      body.push(dataRow)
    })

    return body
  },
  buildTableBodyCustom(data, columns) {
    var body = []

    body.push(...columns)

    data.forEach(function (row) {
      body.push(row)
    })

    return body
  },
  buildTableBodyObject(data, columns) {
    var body = []

    body.push(columns.map((x) => x.text))

    data.forEach(function (row) {
      var dataRow = []

      columns.forEach(function (column) {
        dataRow.push(row[column.value])
      })

      body.push(dataRow)
    })

    return body
  },
  tableCustom(data, columns) {
    return {
      style: 'tableExample',
      table: {
        headerRows: 2,
        body: this.buildTableBodyCustom(data, columns),
        widths: columns[1].map((x) => '*')
      },
      layout: {
        fillColor: function (rowIndex, node, columnIndex) {
          if (rowIndex === 0 || rowIndex === 1) {
            return '#63b3ed'
          } else {
            return rowIndex % 2 === 0 ? '#e2e2e2' : null
          }
        }
      }
    }
  },
  table(data, columns) {
    return {
      columns: [
        { width: '*', text: '' },
        {
          width: 'auto',
          style: 'tableExample',
          table: {
            headerRows: 1,
            body: this.buildTableBody(data, columns),
            width: columns.map(function (d, i) {
              return i === 0 ? '*' : 'auto'
            })
          },
          layout: {
            fillColor: function (rowIndex, node, columnIndex) {
              if (rowIndex === 0) {
                return '#63b3ed'
              } else {
                return rowIndex % 2 === 0 ? '#e2e2e2' : null
              }
            }
          }
        },
        { width: '*', text: '' }
      ],
      margin: [0, 10]
    }
  },
  tableObject(data, columns) {
    return {
      columns: [
        { width: '*', text: '' },
        {
          width: 'auto',
          style: 'tableExample',
          table: {
            headerRows: 1,
            body: this.buildTableBodyObject(data, columns),
            width: columns.map(function (d, i) {
              return i === 0 ? '*' : 'auto'
            })
          },
          layout: {
            fillColor: function (rowIndex, node, columnIndex) {
              if (rowIndex === 0) {
                return '#63b3ed'
              } else {
                return rowIndex % 2 === 0 ? '#e2e2e2' : null
              }
            }
          }
        },
        { width: '*', text: '' }
      ],
      margin: [0, 10]
    }
  },
  get template() {
    return {
      pageSize: 'A4',
      pageMargins: [40, 60, 40, 60],
      header: function (currentPage, pageCount, pageSize) {
        if (currentPage > 1) {
          var _columns = [
            {
              width: '*',
              text: `Generated on ${generatedDate}`,
              color: '#a1afc1',
              style: ['small'],
              margin: [0, 20, 0, 0]
            }
          ]
          var tmLogo = {
            image: base64logo.tm,
            alignment: 'left',
            width: 50
          }
          var _customerLogo = {
            image: customerLogo,
            alignment: 'right',
            width: 80
          }

          if (customerLogo) {
            _columns = [tmLogo].concat(_columns, [_customerLogo])
          } else {
            tmLogo.alignment = 'right'
            tmLogo.width = 60
            _columns.push(tmLogo)
          }

          return {
            columns: _columns,
            margin: [40, 10]
          }
        }
      },
      footer: function (currentPage, pageCount) {
        return {
          columns: [
            {
              // auto-sized columns have their widths based on their content
              width: '*',
              style: ['small'],
              text: `TENANT PORTAL - ${title}`,
              alignment: 'left'
            },
            {
              // % width
              width: 'auto',
              text: currentPage.toString() + ' of ' + pageCount,
              style: ['quote', 'small'],
              alignment: 'right'
            }
          ],
          margin: [40, 0]
        }
      },
      content: content,
      styles: {
        reportHeader: {
          fontSize: 20,
          bold: true,
          color: '#ffffff'
        },
        header: {
          fontSize: 18,
          bold: true
        },
        subheader: {
          fontSize: 15,
          bold: true
        },
        quote: {
          italics: true
        },
        small: {
          fontSize: 8
        },
        coverTitle: {
          fontSize: 12
        },
        coverTitleVal: {
          fontSize: 12,
          bold: true
        },
        tableExample: {
          fontSize: 10
        },
        cellLeft: {
          alignment: 'left'
        },
        cellCenter: {
          alignment: 'center'
        },
        cellRight: {
          alignment: 'right'
        }
      }
    }
  }
}
